import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { resetSelectedRecordObjectInState, getDataByMasterEntityTypeIdAsync, DeleteSelectedAccountCustomFieldAsync } from "./CustomFieldSlice";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom"
import CustomFieldManageItem from "./CustomFieldManageItem";
import { CustomFieldManageForm } from "./CustomFieldManageForm";
import CustomFieldManageOffCanvas from '../../../common/OffCanvas';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { useTranslation } from "react-i18next";
import { getPagePermissionsAsync } from "../../../common/GlobalSlice";
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../../common/Pagination";
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,getValueFromResource} from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';


const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const CustomFieldManage = () => {

    const dispatch = useAppDispatch();
    const { customFieldList, masterEntityTypeList, isReload, selectedRecord, isLoading } = useAppSelector((state) => state.customField);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const MasterEntityTypeId = params.get('MasterEntityTypeId');
    const navigate = useNavigate();
    const [title, setTitle] = useState<string>('');

    const { menuList, IsList, IsAdd, IsEdit, IsDelete, manageTerminologyList } = useAppSelector((state) => state.globalState);
    const { t } = useTranslation();
    const parentPageId: string = '153';
    const pageId: string = '154';

    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const hasFetchedPermissions = useRef(false);
    
    const [isPermissionLoading, setIsPermissionLoading] = useState<boolean>(true);

    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    };

    const filteredData: any = getFilteredList(customFieldList, searchTerm);



    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = customFieldList.length;
    const recordsFiltered = filteredData.length;

    useLayoutEffect(() => {
        if (hasFetchedPermissions.current) return;         
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            }
            setIsPermissionLoading(false);
        };

        const fetchParentPagePermissions = async () => {
            setIsPermissionLoading(true);
            if (parentPageId && parentPageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(parentPageId));
                if (!res.payload.IsList || !res.payload.IsEdit) {
                    navigate('../error/403');
                } else {
                    fetchPagePermissions();
                }
            } else {
                setIsPermissionLoading(false);
            }
        };

        fetchParentPagePermissions();
        hasFetchedPermissions.current = true; 
    }, [dispatch, navigate, pageId, parentPageId]); 

    useEffect(() => {

        
        dispatch(getDataByMasterEntityTypeIdAsync(MasterEntityTypeId));
        if (MasterEntityTypeId !== null) {
            const cachedTitle = localStorage.getItem('ntitle');
            if (cachedTitle !== null) {
                setTitle(cachedTitle);
            } else if (masterEntityTypeList.length > 0) {
                const ntitle = getMasterEntityTypeName(MasterEntityTypeId);
                if (ntitle !== "") {
                    localStorage.setItem('ntitle', ntitle);
                    setTitle(ntitle);
                }
            }
        }
    }, [dispatch, MasterEntityTypeId, isReload]);

    const getMasterEntityTypeName = (MasterEntityTypeId: string) => {
        const selectedRecord = masterEntityTypeList.find(item => item.MasterEntityTypeId == MasterEntityTypeId);
        const selectedField = selectedRecord ? selectedRecord.MasterEntityTypeName : "";
        return selectedField;
    }

    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState())
    }

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(DeleteSelectedAccountCustomFieldAsync(customFieldList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Custom Fields delete Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {
            });

    }

    const generalObject = {
        "name": getValueFromResource(`${title} Custom Fields`, dispatch, t),
        "width": "700px",
        "componentName": <CustomFieldManageForm MasterEntityTypeId={MasterEntityTypeId} t={t} />
    }
    
    if (isLoading || isPermissionLoading) {
        return <Loader />;
    }

    return (
        <>
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top fixed-top bg-white">
                    <h3 className="card-title fw-bold headerTitle" >
                        {getValueFromResource(`${title} Custom Fields`, dispatch, t)}
                    </h3>

                    <div className="card-toolbar align-items-center">
                        {customFieldList.length !== 0 &&
                            <>
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={handleSearch}
                                        placeholder={getValueFromResource('Search', dispatch, t)}
                                        className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                        data-kt-user-table-filter="search"
                                    />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div>
                                <div className='h-35px w-1px mx-1'></div>
                                <div className="d-flex align-items-center">
                                    <PageSizeSelect onChange={handlePageSizeChange} />
                                </div>
                                {(currentItems.length > 0) && (
                                    <>
                                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                        <div>
                                            <CustomPagination
                                                currentPage={currentPage}
                                                onPageChange={handlePageChange}
                                                pageSize={pageSize}
                                                totalItems={totalItems}
                                                start={(currentPage - 1) * pageSize}
                                                t={t}
                                            />
                                        </div>
                                    </>
                                )}
                            </>
                        }
                        {customFieldList.length !== 0 && (IsAdd || (IsDelete && customFieldList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        }

                        {IsAdd &&
                            <a id="kt_OffCanvas"
                                className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                style={{ marginRight: '2px', display: customFieldList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                                onClick={handleOnClickEvent}>
                                {getValueFromResource('Add Custom Field', dispatch, t)}
                            </a>
                        }
                        {IsDelete &&
                            <>
                                <div className="fw-bold me-5" style={{ marginRight: '2px', display: customFieldList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{customFieldList.filter((item: any) => item.isSelected === 1).length}</span> {t('Selected')}
                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: customFieldList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    {getValueFromResource('Delete', dispatch, t)}
                                </button>
                            </>
                        }
                    </div>
                </div>
                {IsList &&
                    <div className="card-body">
                        <div className="table-responsive">
                            <CustomFieldManageItem customFieldList={currentItems} t={t} IsEdit={IsEdit} IsDelete={IsDelete} />
                        </div>
                    </div>
                }
            </div>
            <CustomFieldManageOffCanvas obj={generalObject} />
        </>
    )
}
export default CustomFieldManage;